const i18n = {
  'zh-tw': {
    from: '起',
    book: '預訂',
  },
  'ko-kr': {
    from: '부터',
    book: '예약',
  },
  'en-us': {
    from: 'From',
    book: 'Book',
  },
  'zh-hk': {
    from: '起',
    book: '預訂',
  },
  'zh-my': {
    from: '起',
    book: '预订',
  },
}

const needFloatCurrencies = ['USD', 'SGD', 'MYR']
const fromWordInFront = ['en-us']

function getParameterObject() {
  const querys = window.location.search.substr(1).split('&')
  const querysObject = {}
  querys.forEach((item) => {
    const query = item.split('=')
    querysObject[query[0]] = decodeURIComponent(query[1])
  })

  return querysObject
}

function postMessage(bannerId, isActive = true) {
  const { origin } = getParameterObject()

  if (!isActive) {
    window.parent.postMessage(
      {
        eventIdentify: true,
        bannerId,
        isActive,
      },
      origin,
    )
    return
  }

  const { clientHeight: height, clientWidth: width } = document.getElementById(
    'wapper',
  )
  window.parent.postMessage(
    {
      eventIdentify: true,
      bannerId,
      height,
      width,
      isActive,
    },
    origin,
  )
}

function formatPrice(num, currency) {
  const parts = num.toString().split('.')
  parts[0] = parts[0].replace(/\d(?=(\d{3})+$)/g, '$&,')

  if (typeof parts[1] === 'undefined') {
    parts.push('00')
  }

  if (!needFloatCurrencies.includes(currency.toUpperCase())) {
    parts.pop()
  }

  return parts.join('.')
}

function render(data, affiliateId, bannerId, catId) {
  const apiResponse = JSON.parse(data)
  const { id, bnbs, type } = apiResponse.data.banners[0]
  const bnbCount = bnbs.length
  const { currency, locale } = apiResponse.data.config
  const logoUrl = 'https://img.asiayo.com/static/images/white-main-logo.svg'

  if (bnbCount === 0) {
    postMessage(id, false)
    return
  }

  const body = document.body
  body.className = `locale__${locale}`

  // Wapper
  const wapperMaxWidth = bnbCount * 250
  const wapper = document.createElement('div')
  wapper.setAttribute('id', 'wapper')
  wapper.className = 'wapper'
  wapper.setAttribute('style', `max-width: ${wapperMaxWidth}px`)
  document.getElementById('app').appendChild(wapper)

  // Fragment
  const fragment = document.createDocumentFragment()

  // Container
  const container = document.createElement('div')
  container.className = 'container'
  fragment.appendChild(container)

  bnbs.forEach((bnb) => {
    // Card
    const card = document.createElement('a')
    const cardWidth = (100 / bnbCount).toFixed(2)
    card.setAttribute(
      'style',
      `
      width: calc(${cardWidth}% - 4px);
    `,
    )
    const viewUri = `${
      bnb.bnbURI
    }?aff_id=${affiliateId}&aff_banner_id=${bannerId}&cat_id=${catId}&ucat_id=${type}&utm_medium=affiliate_dynamic_banner`
    card.setAttribute('href', viewUri)
    card.setAttribute('target', '_blank')
    card.className = 'card'

    const bnbPic = document.createElement('div')
    const picUrl = bnb.photoURI.replace('{size}', '750xauto')
    bnbPic.className = 'bnbPic'
    bnbPic.setAttribute('style', `background-image: url('${picUrl}');`)
    card.appendChild(bnbPic)

    // Title
    const title = document.createElement('div')
    title.className = 'title'

    // Logo
    const logo = document.createElement('img')
    logo.className = 'logo'
    logo.setAttribute('src', logoUrl)

    // Address
    const address = document.createTextNode(`${bnb.cityName} ${bnb.areaName}`)
    title.appendChild(logo)
    title.appendChild(address)

    // Detail
    const detail = document.createElement('div')
    detail.className = 'detail'

    // Name
    const name = document.createElement('div')
    const bnbName = document.createTextNode(`${bnb.bnbName}`)
    name.className = 'name'
    name.appendChild(bnbName)

    // Price
    const price = document.createElement('div')
    price.className = 'price'

    // Currency
    const currencyElement = document.createElement('span')
    currencyElement.className = 'priceText'
    currencyElement.setAttribute(
      'style',
      'font-size: 14px; line-height: 20px; font-weight: bold;',
    )
    currencyElement.innerHTML = currency

    // Price amount
    const priceAmount = document.createElement('span')
    priceAmount.className = 'priceText'
    priceAmount.setAttribute(
      'style',
      'font-size: 20px; line-height: 28px; font-weight: bold;',
    )
    priceAmount.innerHTML = formatPrice(bnb.price, currency)

    // word
    const word = document.createElement('span')
    word.className = 'priceText'
    word.setAttribute('style', 'font-size: 12px; line-height: 16px;')
    word.innerHTML = i18n[locale].from

    if (fromWordInFront.includes(locale)) {
      price.appendChild(word)
      price.appendChild(currencyElement)
      price.appendChild(priceAmount)
    } else {
      price.appendChild(currencyElement)
      price.appendChild(priceAmount)
      price.appendChild(word)
    }

    // Button
    const button = document.createElement('div')
    button.className = 'button'
    button.innerHTML = i18n[locale].book

    detail.appendChild(name)
    detail.appendChild(price)
    detail.appendChild(button)

    card.appendChild(title)
    card.appendChild(detail)

    container.appendChild(card)
  })

  wapper.appendChild(fragment)
  postMessage(id, true)
}

const xhr = new XMLHttpRequest()
const { affiliateId, bannerId, catId } = getParameterObject()
xhr.open('GET', `/aff-api/v2/affiliate/banner/${bannerId}`)
xhr.setRequestHeader('x-app-platform', 'web')
xhr.onload = function onload() {
  if (xhr.status === 200) {
    render(xhr.responseText, affiliateId, bannerId, catId)
  } else {
    postMessage(0, false)
  }
}
xhr.send()
